import { WhyGrid } from "@/components/home/WhyGrid";
import { Results } from "@/components/home/Results";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SectionHeading } from "@/components/site/ui";
import { useSeo } from "@/lib/seo";

export default function WhySudigi() {
    useSeo({ title: "Why Sudigi — Your Affordable Digital Growth Partner | SUDIGI", description: "Affordable entry, one growth partner, transparent pricing, human support and trackable execution — built for Indian local businesses." });
    return (
        <>
            <section className="bg-gradient-to-b from-teal-950 to-teal-900 pt-16 pb-6 grain">
                <div className="container-x text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="About Sudigi" title="Built for Indian Businesses That Want to Grow"
                        subtitle="We combine affordable pricing with professional execution and a dedicated human who actually understands your business." />
                </div>
            </section>
            <WhyGrid />
            <Results />
            <FinalCTA />
        </>
    );
}
